import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { FolderKanban, Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Projects() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", description: "" });

  const load = () => api.get("/projects").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing) await api.patch(`/projects/${editing.id}`, form);
      else await api.post("/projects", form);
      toast.success("Saved"); setOpen(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/projects/${id}`); load(); };

  return (
    <>
      <PageHeader
        eyebrow="Organization"
        title="Projects"
        subtitle="Business initiatives your employees are billed to"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button data-testid="new-project-btn" onClick={() => { setEditing(null); setForm({ name: "", description: "" }); setOpen(true); }} className="rounded-none btn-primary-brand">
                <Plus className="h-4 w-4 mr-1" /> New project
              </Button>
            </DialogTrigger>
            <DialogContent className="rounded-none bg-card border-border">
              <DialogHeader><DialogTitle className="font-display">{editing ? "Edit project" : "New project"}</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label className="label-mono">Name</Label><Input data-testid="project-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-none" /></div>
                <div><Label className="label-mono">Description</Label><Input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="rounded-none" /></div>
              </div>
              <DialogFooter><Button data-testid="project-save-btn" onClick={save} className="rounded-none btn-primary-brand">Save</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <Card key={p.id} className="rounded-none border-border p-5 flex items-start justify-between">
            <div className="flex items-start gap-3">
              <FolderKanban className="h-5 w-5 text-muted-foreground mt-0.5" strokeWidth={1.5} />
              <div>
                <div className="font-display text-lg">{p.name}</div>
                <div className="text-sm text-muted-foreground">{p.description || "—"}</div>
              </div>
            </div>
            <div className="flex gap-1">
              <button onClick={() => { setEditing(p); setForm({ name: p.name, description: p.description || "" }); setOpen(true); }} className="p-2 border border-border hover:bg-secondary"><Pencil className="h-3.5 w-3.5" strokeWidth={1.5} /></button>
              <button onClick={() => del(p.id)} className="p-2 border border-border hover:bg-secondary"><Trash2 className="h-3.5 w-3.5" strokeWidth={1.5} /></button>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
